import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import { onEntryChange } from 'utilities/contentStack';

import {
  getProductStack,
  clearProductStack
} from 'features/product/detail/actions';

const LegacyPage = loadable(() => import('./LegacyProductPage'));
const Page = loadable(() => import('./ProductPage'));

const ProductDetail = ({
  getProductStack,
  clearProductStack,
  stack,
  legacy,
  match
}) => {
  useEffect(() => {
    getProductStack(`/products/${match.params.family}/${match.params.name}`);
    return () => clearProductStack();
  }, [
    match.params.name,
    match.params.family,
    getProductStack,
    clearProductStack
  ]);

  useEffect(() => {
    onEntryChange(() => {
      getProductStack(`/products/${match.params.family}/${match.params.name}`);
    });
  }, [match.params.name, getProductStack, match.params.family]);

  return stack.uid ? <>{legacy ? <LegacyPage /> : <Page />}</> : null;
};

export default connect(
  state => ({
    stack: state.product.stack,
    legacy: state.product.legacy,
    loading: state.product.loading
  }),
  {
    getProductStack,
    clearProductStack
  }
)(ProductDetail);
